import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PickingProductivityComponent } from './picking-productivity.component';

const routes: Routes = [
  {
    path: '',
    component: PickingProductivityComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PickingProductivityRoutingModule { }
